import { InviteProjectionStore } from './store'

export * from './store'
export const inviteStore = InviteProjectionStore.new()
